import React from 'react';

const EngagementSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='31'
      viewBox='0 0 30 31'
      fill='none'
      onClick={onClick}
      className={className}
      {...props}
    >
      <rect y='0.5' width='30' height='30' rx='4' fill='#DFF4FF' />
      <path
        d='M11 15.5H11.009M14.991 15.5H15M18.991 15.5H19'
        stroke='#0744E1'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 25.5C20.5228 25.5 25 21.0228 25 15.5C25 9.97715 20.5228 5.5 15 5.5C9.47715 5.5 5 9.97715 5 15.5C5 17.0997 5.37562 18.6116 6.04346 19.9525C6.22094 20.3088 6.28001 20.7161 6.17712 21.1006L5.58151 23.3267C5.32295 24.293 6.20701 25.177 7.17335 24.9185L9.39939 24.3229C9.78393 24.22 10.1912 24.2791 10.5475 24.4565C11.8884 25.1244 13.4003 25.5 15 25.5Z'
        stroke='#0744E1'
        strokeWidth='1.4'
      />
    </svg>
  );
};

export default EngagementSVG;
